import React, {Component} from 'react';
import {FlexIndicatorConfiguration} from "./FlexIndicatorConfiguration";
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {SaveButton} from "../../business_units/SaveButton";
import {Spinner} from "../../Spinner";
import { withTranslation } from 'react-i18next';

class FlexIndicatorsComponentClass extends Component {
    static MAX_FLEX_INDICATORS = 12;

    constructor(props) {
        super(props);

        this.handleFlexIndicatorChange = this.handleFlexIndicatorChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        const initialState = {
            loading: true,
            isSaving: false,
            hasChanges: false,
            hasAccessToModule: null
        };

        for (let i = 1; i <= FlexIndicatorsComponentClass.MAX_FLEX_INDICATORS; i++) {
            initialState[`agencyFlexIndicator${i}`] = null;
        }

        this.state = initialState;
    }

    getPostData() {
        const postData = [];

        for (let i = 1; i <= FlexIndicatorsComponentClass.MAX_FLEX_INDICATORS; i++) {
            let newData = {};
            if (this.state[`agencyFlexIndicator${i}`] == null) {
                newData = null;
            } else {
                newData["metric_name"] = this.state[`agencyFlexIndicator${i}`]['metricName'];
                newData["main_period"] = this.state[`agencyFlexIndicator${i}`]['mainPeriod'];
                newData["vs_period"] = this.state[`agencyFlexIndicator${i}`]['vsPeriod'];
            }
            postData.push(newData);
        }

        return postData;
    }

    handleSubmit() {

        this.setState({isSaving: true});

        this.postForm(this.getPostData()).then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({hasChanges: false});
            } else if (response.status === 'NO_MODULE_ACCESS') {
                alert(response.error_message);
            }
            this.setState({isSaving: false});
        });
    }

    postForm(data) {
        const apiClient = new APIClient(this.getFlexIndicatirsSubmitUrl());
        return apiClient.call('PUT', data);
    }

    componentDidMount() {
        this.getAgencyFlexIndicators();
    }

    getAgencyFlexIndicators() {
        new APIClient(this.getFlexIndicatorsUrl()).call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'NO_MODULE_ACCESS') {
                this.setState({hasAccessToModule: false, loading: false});
            } else if (data.status === 'OK') {

                const initialFlexIndicatorsStatus = {};
                for (let i = 0; i < data.data.length; i++) {
                    const flexIndicatorData = data.data[i];
                    if (i >= FlexIndicatorsComponentClass.MAX_FLEX_INDICATORS || flexIndicatorData == null) {
                        continue
                    }

                    initialFlexIndicatorsStatus[`agencyFlexIndicator${(i + 1)}`] = {
                        "metricName": flexIndicatorData.metric_name,
                        "mainPeriod": flexIndicatorData.main_period,
                        "vsPeriod": flexIndicatorData.vs_period,
                    };
                }

                this.setState({...initialFlexIndicatorsStatus, hasAccessToModule: true, loading: false});
            }
        })
    }

    getFlexIndicatorsUrl() {
        return API_URL + 'agency/flex-indicator/';
    }

    getFlexIndicatirsSubmitUrl() {
        return API_URL + 'agency/flex-indicator/update-all'
    }

    isDataValidFlexIndicatorConfiguration(newValue) {
        if (newValue == null) {
            return true;
        }

        return newValue["metricName"] != null && newValue["mainPeriod"] != null;
    }

    handleFlexIndicatorChange(order, newValue) {
        const newStatus = {};
        newStatus[`agencyFlexIndicator${order}`] = this.isDataValidFlexIndicatorConfiguration(newValue) ? newValue : null;
        newStatus[`hasChanges`] = true;
        this.setState({...newStatus})
    }

    getActiveCount() {
        let count = 0;
        for (let i = 1; i <= FlexIndicatorsComponentClass.MAX_FLEX_INDICATORS; i++) {
            if (this.state[`agencyFlexIndicator${i}`] != null) {
                count++;
            }
        }
        return count;
    }

    renderSaveButton() {
        const { t } = this.props;
        return (
            <div className="d-flex">
                <SaveButton text={t('flex_indicators_component.save_button')}
                                isSaving={this.state.isSaving}
                                onClick={this.handleSubmit}
                                hasChanges={this.state.hasChanges}/>
            </div>
        );
    }

    render() {
        const { t } = this.props;
        return (
            <div className="section-body-item -widest box">
                <header className="box-header">
                    <h2 className="box-title">{t('flex_indicators_component.title')}</h2>
                </header>
                {this.renderInnerComponents()}
            </div>
        )
    }

    renderAccessStatus() {
        const { t } = this.props;
        if (this.state.hasAccessToModule)
            return;

        return <div className="row" style={{marginRight: 0, marginLeft: 0, marginBottom: '1.3em'}}>
            <div className="alert alert-info">
                {t('flex_indicators_component.agency_plan_required')}
            </div>
        </div>
    }

    renderInnerComponents() {
        if (this.state.loading === true) {
            return <div className="box-loader">
                <Spinner color="positive"/>
            </div>
        }

        const { t } = this.props;
        const activeCount = this.getActiveCount();
        return [
            <div key="header" className="flex-indicators-header">
                <label>{t('flex_indicators_component.description')}</label>
                <span className="flex-indicators-counter">
                    <span className="counter-active">{activeCount}</span> / {FlexIndicatorsComponentClass.MAX_FLEX_INDICATORS} {t('flex_indicators_component.counter')}
                </span>
            </div>,
            this.renderAccessStatus(),
            this.renderFlexIndicatorComponents(),
            this.renderSaveButton()
        ];
    }

    renderFlexIndicatorComponents() {
        const flexIndicatorComponents = [];

        for (let i = 1; i <= FlexIndicatorsComponentClass.MAX_FLEX_INDICATORS; i++) {
            const key = `flexIndicatorConfig-${i}`;

            flexIndicatorComponents.push(
                <FlexIndicatorConfiguration
                    key={key}
                    order={i}
                    data={this.state[`agencyFlexIndicator${i}`]}
                    onChange={this.handleFlexIndicatorChange}
                />
            );
        }

        return <div key="grid" className="flex-indicators-grid">{flexIndicatorComponents}</div>;
    }
}

export const FlexIndicatorsComponent = withTranslation()(FlexIndicatorsComponentClass);
export default FlexIndicatorsComponent;
